import { createMuiTheme } from '@material-ui/core/styles';
import { palette, fonts } from './../../config/branding'; // has to be relative for ssr rendering

export default createMuiTheme({
  typography: {
    fontFamily: 'HelveticaNeue", sans-serif',
    fontSize: 12,
    button: {
      fontWeight: 'normal',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        fontFamily: fonts.primary.bold,
        borderRadius: 0,
        color: palette.global03,
        backgroundColor: palette.global01,
        padding: '5px',
        '&:hover': {
          color: palette.global03,
          backgroundColor: palette.global02,
        },
      },
      disabled: {
        backgroundColor: `${palette.global01}99`,
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: palette.global01,
        boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.17)',
        borderRadius: '4px',
      },
    },
  },
  palette: {
    primary: { main: palette.global01 },
    secondary: { main: palette.global02 },
    action: { disabled: palette.neutral01 },
  },
});



// WEBPACK FOOTER //
// /opt/build/repo/src/app/connectors/styling/muiTheme.js